import {
  defineNuxtRouteMiddleware,
  navigateTo,
} from 'nuxt/app';
import routes from '@routes';
import { useRoute } from 'vue-router';

export default defineNuxtRouteMiddleware(() => {
  const route = useRoute();

  if (window.innerWidth > 1024) {
    return navigateTo({ path: `/${routes.myRequests}/${route.params.id}/berichtenbox` });
  }
});
